import { ArrowDropDown } from "@mui/icons-material"
import { Button, Menu, MenuItem, Typography, Grid } from "@mui/material"
import { useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { clearAuthStore, getUserEmail, getUserName, getUserRoleTypeStatus, setUserLoggedOut } from "../../store/OktaAuthSlice"
import { clearDropDownData, clearFormData } from "../../store/formSlice"
import OktaAuth from "@okta/okta-auth-js"
import { oktaConfig, oktaExternalConfig } from "../../common/okta/Okta.Config"
import { useOktaAuth } from "@okta/okta-react"

const menuItemStyle = {
    '&:hover': {
        backgroundColor: 'rgba(0, 0, 0, 0.1)'
    }
}

const oktaAuthInt = new OktaAuth(oktaConfig);

const oktaAuthExt = new OktaAuth(oktaExternalConfig);

const UserProfile = () => {

    const { oktaAuth } = useOktaAuth();

    const isInternal = useSelector(getUserRoleTypeStatus);

    const userEmail = useSelector(getUserEmail);

    const userName = useSelector(getUserName);

    const dispatch = useDispatch();

    const [anchorEl, setAnchorE1] = useState(null);

    const isMenuOpen = Boolean(anchorEl);

    const handleMenuOpen = (event: any) => {
        setAnchorE1(event.currentTarget)
    }

    const handleMenuClose = () => {
        setAnchorE1(null);
    }

    const handleLogout = async () => {
        setAnchorE1(null);
        dispatch(clearAuthStore());
        dispatch(clearFormData());
        dispatch(clearDropDownData());
        oktaAuth.tokenManager.clear();
        oktaAuth.closeSession();
        localStorage.clear();
        try {
            if (isInternal) {
                oktaAuthInt.signOut();
            } else {
                oktaAuthExt.signOut();
            }
        } catch (e) {
            console.log("Error in logout action")
        }
        await oktaAuth.signOut().then(res => {
            console.log("You have been successfully logged out!");
            dispatch(setUserLoggedOut(true));
        });
    }

    return (
        <Grid container spacing={2} sx={{ position: 'absolute', top: 8, zIndex: 9999 }}>
        {/* Empty Columns for Alignment */}
       {/*  <Grid item xs={4}></Grid>
        <Grid item xs={4}></Grid> */}
        
        {/* 4th Column: User Profile */}
        <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
        <Button
  variant="text"
  style={{ color: 'white' }}
  endIcon={<ArrowDropDown />}
  onClick={handleMenuOpen}
  sx={{
    minWidth: { xs: '120px', sm: '150px', md: 'auto' }, // Ensure enough space for the arrow
    fontSize: { xs: '0.8rem', sm: '1rem', md: '1rem' }, // Adjust font size for smaller screens
    display: 'flex', // Ensure proper alignment of text and icon
    justifyContent: 'space-between', // Space out text and icon
  }}
>
  <Typography
    variant="body1"
    sx={{
      fontSize: { xs: '0.8rem', sm: '1rem', md: '1rem' }, // Adjust font size for smaller screens
      overflow: 'hidden', // Prevent overflow issues
      textOverflow: 'ellipsis', // Add ellipsis for long text
      whiteSpace: 'nowrap', // Prevent text wrapping
    }}
  >
    {userName}
  </Typography>
</Button>
<Menu
  anchorEl={anchorEl}
  open={isMenuOpen}
  onClose={handleMenuClose}
  anchorOrigin={{
    vertical: 'top',
    horizontal: 'right', // Align to the right
  }}
  transformOrigin={{
    vertical: 'top',
    horizontal: 'right', // Align to the right
  }}
  sx={{
    '& .MuiMenu-list': {
      paddingTop: '2px',
      paddingBottom: '2px',
    },
    '& .MuiMenuItem-root': {
      padding: '2px 10px',
      minHeight: '35px',
      fontSize: { xs: '0.7rem', sm: '0.8rem', md: '0.8rem' }, // Adjust font size for smaller screens
    },
    top: '30px',
  }}
>
  <MenuItem disabled={true}>{userEmail}</MenuItem>
  <MenuItem sx={menuItemStyle} onClick={handleLogout}>
    Logout
  </MenuItem>
</Menu>
        </Grid>
      </Grid>
    )
}

export default UserProfile;